import { useSelector } from 'react-redux';
import theme from '../theme';

export const useGetTheme = () => {
  const dark = useSelector((state) => state.basic.dark);
  return dark ? theme.palette.dark : theme.palette.light;
};
